import { Application } from "@hotwired/stimulus"
import { railsEnv } from "@uenf/layout"

const application = Application.start()

if (railsEnv === "development") {
  application.warnings = true
  application.debug    = true
  window.Stimulus      = application
}

import { layoutControllers } from "@uenf/layout"
for (const [name, controller] of Object.entries(layoutControllers)) {
  application.register(name, controller);
}

import { definitions } from "stimulus:./controllers"
application.load(definitions);

import CheckboxesAsRadiosController from "@uenf/layout/controllers/checkboxes-as-radios";
application.register("checkboxes-as-radios", CheckboxesAsRadiosController);

import CnpjLookupController from "@uenf/layout/controllers/cnpj-lookup";
application.register("cnpj-lookup", CnpjLookupController);

import CheckboxSelectAll from "@stimulus-components/checkbox-select-all";
application.register("checkbox-select-all", CheckboxSelectAll);

import AutocompleteController from "@uenf/layout/controllers/autocomplete"
application.register("autocomplete", AutocompleteController);
